import { useState } from 'react';

import { IconButton } from '@opositandopn/ui';
import { IoAddCircleOutline } from 'react-icons/io5';

import { Page } from '../../components/shared/page/Page';
import { TrainingPlanAdminList } from '../../features/physical-tests/components/training-plan-admin-list/TrainingPlanAdminList';
import { TrainingPlanEditor } from '../../features/physical-tests/components/training-plan-editor/TrainingPlanEditor';

import styles from './TrainingPlanListPage.module.scss';

function TrainingPlanListPage() {
  const [showNew, setShowNew] = useState(false);

  return (
    <Page className={styles['page']}>
      <div className={styles['header']}>
        <IconButton
          icon={<IoAddCircleOutline />}
          onClick={() => {
            setShowNew(true);
          }}
        />
      </div>
      <TrainingPlanAdminList />
      <TrainingPlanEditor open={showNew} onClose={() => setShowNew(false)} />
    </Page>
  );
}

export { TrainingPlanListPage };
